/**
 * Imports a module by URL, bypassing Vite's import analysis. The URL carries a
 * cache-busting query: a browser keeps a failed module fetch for the life of
 * the document, so retrying the same URL cannot succeed. Kept in its own module
 * so tests can replace the network import.
 */
export function importFresh(url: string): Promise<unknown> {
  return import(/* @vite-ignore */ url);
}
